import { Outlet } from 'react-router-dom';
import { Header, HeaderSpacer } from '@/components/ui';

/**
 * Layout Component
 * Main application layout with professional header and content area
 *
 * Uses the new design system with Bloomberg Terminal-inspired aesthetics:
 * - Fixed header with navigation
 * - Clean background color
 * - Proper spacing and padding
 */
export function Layout(): React.ReactElement {
  return (
    <div className="min-h-screen bg-background-alt">
      {/* Professional Header */}
      <Header />

      {/* Main Content Area */}
      <main>
        <HeaderSpacer />
        <div className="p-6 max-w-[1600px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
